export const howRagWorksData = [
  {
    step: '1',
    title: 'Knowledge Ingestion',
    description:
      'We connect to all relevant data sources your company has: SharePoint, Confluence, Slack, databases, file servers, and collaboration tools. Our system processes documents, emails, wikis, and technical specs into a unified knowledge graph.',
    stepColor: 'blue',
  },
  {
    step: '2',
    title: 'Intelligent Indexing',
    description:
      'Content is transformed into vector embeddings that capture semantic meaning, not just keywords. This enables true understanding of context, relationships, and domain-specific terminology.',
    stepColor: 'blue',
  },
  {
    step: '3',
    title: 'Smart Retrieval',
    description:
      'When an employee asks a question, the system analyzes the query, searches the entire knowledge base using semantic search, and retrieves the most relevant passages.',
    stepColor: 'blue',
  },
  {
    step: '4',
    title: 'Grounded Generation',
    description:
      'Retrieved information feeds into the AI model, which generates a precise, contextualized answer.',
    stepColor: 'blue',
  },
  {
    step: '5',
    title: 'Continuous Learning',
    description:
      'The system stays current as your knowledge base evolves, automatically indexing new documents and maintaining accuracy without costly retraining.',
    stepColor: 'blue',
  },
];

export const customThresholds = [0, 32, 54, 70, 90];
